const customer = [{
  desc: '人员查询',
  options: {
    url: '/customer/GetCustomerList',
    method: 'post'
  }
}, {
  desc: '批量人员管理',
  options: {
    url: '/customer/LotAddOrUpdateCustomer',
    method: 'post'
  }
}, {
  desc: '人员收款人新增编辑删除接口',
  options: {
    url: '/customer/PayeelistAddOrUpdate',
    method: 'post'
  }
}, {
  desc: '人员新增编辑删除接口',
  options: {
    url: '/customer/UpdateCustomer',
    method: 'post'
  }
}, {
  desc: '返回当前登录人人员信息',
  options: {
    url: '/customer/loginCustomer',
    method: 'post'
  },
  vuex: true
}, {
  desc: '根据商户编码查询绑定的供应商',
  options: {
    url: '/partnerBranch/querySupplierBySubDomain',
    method: 'post',
    argsParams: true
  }
}, {
  desc: '获取待认证人数',
  options: {
    url: '/customer/GetAuthenticationApprovalCount',
    method: 'post'
  }
}, {
  desc: '获取省接口',
  options: {
    url: '/customer/GetProvince',
    method: 'get'
  },
  vuex: false
}, {
  desc: '获取市接口',
  options: {
    url: '/customer/GetProvinceCity',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '获取区接口',
  options: {
    url: '/customer/GetCityDistrict',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '获取新省份接口',
  options: {
    url: '/base/natGeo/queryAllProvince',
    method: 'get',
    baseURL: '/insapi/v3/insured'
  },
  vuex: false
}, {
  desc: '获取新城市和地区接口',
  options: {
    url: '/base/natGeo/queryProvinceCityDistrict',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '菜单查询接口',
  options: {
    url: '/customer/getMenu',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '人员禁用启用接口',
  options: {
    url: '/customer/CustomerDisableOrEnable',
    method: 'post'
  }
}, {
  desc: '获取筛选条件的组织机构信息',
  options: {
    url: '/customer/GetSmallOrganization',
    method: 'post'
  },
  vuex: true
}, {
  desc: '获取筛选条件的人员信息',
  options: {
    url: '/customer/GetSmallCustomer',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    formdata: true // 是否通过formdata的方式传参
  }
}, {
  desc: '获取筛选条件的人员信息(收款人信息)',
  options: {
    url: '/customer/getCustomerContainOfficeType3',
    method: 'post'
  }
}, {
  desc: '修改密码',
  options: {
    url: '/customer/updatePwd',
    method: 'post'
  }
}, {
  desc: '结算人列表',
  options: {
    url: '/customer/GetSimpleCustomer',
    method: 'post'
  }
}, {
  desc: '查询人员是否有绑定优保联公众号',
  options: {
    url: '/customer/queryOpenIdById',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '发送验证码',
  options: {
    url: '/customer/sendWeiXinCode'
  }
}, {
  desc: '人员绑定或解绑优保联公众号',
  options: {
    url: '/customer/bindingOrCancelWechat',
    method: 'post'
  }
}, {
  desc: '增员二维码',
  options: {
    url: '/regCertificate/createQrCodeFromPlatform',
    method: 'post'
  }
}, {
  desc: '业绩走势图保费、净保费、收入、支出、利润统计查询接口',
  options: {
    url: '/homeShowData/getInsStatistics',
    method: 'post'
  }
}, {
  desc: '首页横向数据全部',
  options: {
    url: '/homeShowData/queryHomeShowDataAll',
    method: 'post'
  }
}, {
  desc: '首页横向数据车险',
  options: {
    url: '/homeShowData/queryHomeShowDataCar',
    method: 'post'
  }
}, {
  desc: '首页横向数据非车',
  options: {
    url: '/homeShowData/queryHomeShowDataFc',
    method: 'post'
  }
}, {
  desc: '快捷工作台查询',
  options: {
    url: '/workbenches/queryAllByCustomerId',
    method: 'post'
  }
}, {
  desc: '快捷工作台新增修改',
  options: {
    url: '/workbenches/saveOrUpdateWorkbenches',
    method: 'post'
  }
}, {
  desc: '查询验证码是否存在',
  options: {
    url: '/customer/checkCode',
    method: 'get'
  }
}]
export default customer



// WEBPACK FOOTER //
// ./src/api/customer.js